import styled from 'styled-components';

const FileExpiry = styled.div`
  font-size: 11px;
  opacity: 0.6;
  font-style: italic;
`;

export default FileExpiry;
